import React from 'react';
import { Box } from '@mui/material';
import PageHeader from './PageHeader';
import Audit from './Audit';

/** In/Out page (formerly nested under /logs/audit). */
const LogsPage = () => {
  return (
    <Box>
      <PageHeader
        title="In/Out"
        subtitle="In and out recognition logs"
        icon={null}
      />

      <Box sx={{ minWidth: 0 }}>
        <Audit view="logs" embedded />
      </Box>
    </Box>
  );
};

export default LogsPage;
